import Icon from '@kk/ui/components/Icon/Icon';
import { useTranslation } from 'react-i18next';

export type FooterProps = {
  address?: string;
  phone?: string;
};

export function Footer({
  address = 'Store Kongensgade 72C, 1264 København K',
  phone = '+45 3315 4464',
}: FooterProps) {
  const { t } = useTranslation();

  const links = [
    {
      label: t('footer.data.protection'),
      url: '/',
      target: '_blank',
    },
    {
      label: t('footer.availability.statement'),
      url: '/',
      target: '_blank',
    },
    {
      label: t('footer.cookie.settings'),
      url: '/',
      target: '_blank',
    },
  ];

  return (
    <footer
      className={
        'typ-body-xs flex min-h-13 w-full flex-col items-start justify-start px-6 py-4 text-neutral-100 md:flex-row md:flex-wrap md:items-center md:justify-between md:gap-y-2'
      }
    >
      <div
        className={
          'flex flex-col flex-wrap space-y-2 md:inline-flex md:flex-row lg:flex-nowrap lg:space-y-0'
        }
      >
        <div
          className={
            'md:typ-body-xs typ-body-bold flex w-fit items-center justify-start pb-2 pr-0 font-bold text-blue-100 md:pb-0 md:pr-4 md:font-semibold'
          }
        >
          {t('app.kk')}
        </div>
        <div
          className={
            'lg:border-l-neutral-60 flex w-full flex-col justify-start gap-1 border-l-0 md:flex-row md:gap-4 md:pr-6 lg:w-fit lg:border-l lg:pl-4'
          }
        >
          <div
            className={
              'flex w-fit flex-nowrap items-center gap-2 whitespace-nowrap not-italic'
            }
          >
            <Icon type={'home'} className={'size-4'} />
            <address className={'not-italic'}>{address}</address>
          </div>
          <div
            className={
              'flex w-fit flex-nowrap items-center gap-2 whitespace-nowrap'
            }
          >
            <Icon type={'phone'} className={'size-4'} />
            <a className={``} href={`tel:${phone}`}>
              {phone}
            </a>
          </div>
          <div
            className={
              'flex w-fit flex-nowrap items-center gap-2 whitespace-nowrap'
            }
          >
            <Icon type={'tag'} className={'size-4'} />
            <span>CVR: 22128612</span>
          </div>
        </div>
      </div>
      <div
        className={
          'lg:border-l-neutral-60 flex w-fit flex-col justify-end gap-1 pr-0 pt-4 md:flex-row md:gap-4 md:pt-0 lg:border-l lg:pl-6'
        }
      >
        {links.map((link, index) => (
          <a
            key={`link-${index}`}
            href={link.url}
            target={link.target}
            className={
              'flex w-fit flex-nowrap whitespace-nowrap underline hover:no-underline'
            }
          >
            {link.label}
          </a>
        ))}
      </div>
    </footer>
  );
}

export default Footer;
